import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide,
  Button
} from '@mui/material'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import {
  ChevronDown,
  ChevronRight,
  Circle,
  CircleHalfFull,
  MenuDown
} from 'mdi-material-ui'
import {
  addCommas,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  unique
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'

interface Props {
  setCurrent: any
  setOpen: any
  setHistoryOpen: any
  setCommentsOpen: any
  setTranscript_list: any
  handleMenuClick: any
  getColumnSearchProps: any
  setFilterGeneOpen: any
  setMenuType: any
  setFilterGeneData: any
  getFilterGene: any
  setIndexOpen: any
  setGeneIndexOpen: any
  setGeneOpen: any
  setAcmgOpen: any
  setOMIMOpen: any
  setIgvOpen: any
  setIgvLocus: any
  setCnvScipOpen: any
  setCnvAllOpen: any
  setSamplesOpen: any
  setSampleInfoOpen: any
  VariationGeneRef: any
  analysisInfo: any
  query: any
  indexChecked: boolean
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns2CohortSites = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const column: TableColumnsType<Variation> = React.useMemo(() => {
    let column: TableColumnsType<Variation> = [
      // {
      //   dataIndex: 'grading',
      //   key: 'grading',
      //   align: 'center',
      //   width: 80,
      //   ellipsis: true,
      //   sorter: true,
      //   title: () => <span>{t('Classification')}</span>,
      //   render: (value, row: any) => {
      //     if (row.user_classification) {
      //       const bgcolor = GLScolor.find(
      //         (i) => i.key === row.user_classification
      //       )
      //         ? (color.find((i) => i.key === row.user_classification)?.color as
      //             | 'rgb(240,239,240,0.4)'
      //             | 'rgba(221,109,32,0.8)'
      //             | 'rgb(255,242,202)'
      //             | 'rgb(245,182,193)')
      //         : 'rgba(0, 0, 0)'

      //       return (
      //         <Stack direction={'column'}>
      //           <Box sx={{ textAlign: 'center' }}>
      //             <Chip
      //               key={row.user_classification}
      //               size="small"
      //               label={`${row.user_classification
      //                 .split(' ')
      //                 .map((word: any) => {
      //                   if (word.includes('Uncertain')) return `VU`
      //                   if (word.includes('uncertain')) return `VU`
      //                   if (word.includes('null')) return ``
      //                   else return word[0].toUpperCase()
      //                 })
      //                 .join('')}`}
      //               sx={{
      //                 bgcolor: bgcolor,
      //                 color:
      //                   bgcolor === 'rgb(240,239,240,0.4)' ? 'black' : 'white',
      //                 justifyContent: 'center',
      //                 fontSize: '0.75rem',
      //                 fontWeight: 700,
      //                 textAlign: 'center',
      //                 minWidth: '45px'
      //               }}
      //               onClick={() => {
      //                 props.setCurrent(row)

      //                 props.setOpen(true)
      //               }}
      //             />
      //           </Box>
      //         </Stack>
      //       )
      //     } else {
      //       return (
      //         <Stack direction={'column'} width="100%" height={'100%'}>
      //           <Box textAlign={'center'}>
      //             <IconButton
      //               aria-label="edit"
      //               onClick={() => {
      //                 props.setCurrent(row)

      //                 props.setOpen(true)
      //               }}
      //               sx={{
      //                 padding: 0
      //               }}
      //             >
      //               <CommentOutline
      //                 sx={{
      //                   fontSize: '1rem'
      //                 }}
      //               />
      //             </IconButton>
      //           </Box>
      //         </Stack>
      //       )
      //     }
      //   }
      // },

      {
        dataIndex: 'gene',
        key: 'gene',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            {/* <Filters keys="gene" /> */}

            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('Gene')}
              </span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('TranscriptID')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          let bgcolor = color.find(
            (i) => i.key === row.CLINSIG_final?.toLowerCase()
          )
            ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                ?.color as any)
            : 'rgba(0, 0, 0)'

          const badges = row.user_variant_comments
            ? row.user_variant_comments.comments.length
            : 0

          const hisBadges = row.tempHistory ? row.tempHistory.length : 0

          // loss_of_function等于1 并且CLINSIG_final不等于P/LP
          if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
            //
          } else if (row.CLINSIG_final?.toLowerCase() === 'likely pathogenic') {
            //
          } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'
          const NM = `${row.transcript}(MANE)`

          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <Stack
                direction="row"
                alignItems={'center'}
                justifyContent="space-between"
                width={'100%'}
              >
                {ability &&
                ability.can('read', 'report-search') &&
                hisBadges ? (
                  <Badges
                    onClick={(e) => {
                      props.setHistoryOpen(true)

                      props.setCurrent(row)
                    }}
                    showZero
                    badgeContent={hisBadges}
                    color="primary"
                    sx={{
                      cursor: 'pointer',
                      color: 'inherit',
                      '& .MuiBadge-badge': {
                        top: '6px',
                        right: '-45px'
                      }
                    }}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                  >
                    <Badges
                      onClick={(e) => {
                        props.setCommentsOpen(true)

                        //

                        props.setCurrent(row)
                      }}
                      showZero
                      badgeContent={badges}
                      color="primary"
                      sx={{
                        cursor: 'pointer',
                        color: 'inherit',
                        '& .MuiBadge-badge': {
                          top: '6px',
                          right: '-18px'
                        }
                      }}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                      }}
                    >
                      <TypographyA
                        sx={{
                          color:
                            bgcolor === 'rgba(229,38,35,0.8)'
                              ? 'white'
                              : bgcolor === 'rgb(107,148,200,0.8)' ||
                                bgcolor === 'rgb(109,56,149,0.8)'
                              ? 'black'
                              : '#23527c',
                          fontWeight: '700'
                        }}
                      >
                        {row.gene}
                      </TypographyA>
                    </Badges>
                  </Badges>
                ) : (
                  <Badges
                    onClick={(e) => {
                      props.setCommentsOpen(true)

                      //

                      props.setCurrent(row)
                    }}
                    showZero
                    badgeContent={badges}
                    color="primary"
                    sx={{
                      cursor: 'pointer',
                      color: 'inherit',
                      '& .MuiBadge-badge': {
                        top: '6px',
                        right: '-18px'
                      }
                    }}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                  >
                    <TypographyA
                      sx={{
                        color:
                          bgcolor === 'rgba(229,38,35,0.8)'
                            ? 'white'
                            : bgcolor === 'rgb(107,148,200,0.8)' ||
                              bgcolor === 'rgb(109,56,149,0.8)'
                            ? 'black'
                            : '#23527c',
                        fontWeight: '700'
                      }}
                    >
                      {row.gene}
                    </TypographyA>
                  </Badges>
                )}

                {row && row.getCanExpand && row.getCanExpand() ? (
                  <button
                    {...{
                      onClick: row.getToggleExpandedHandler(),
                      style: { cursor: 'pointer' }
                    }}
                  >
                    {row.getIsExpanded() ? (
                      <IconButton
                        sx={{
                          '& .MuiSvgIcon-root': {
                            color: 'black'
                          },
                          padding: 0
                        }}
                      >
                        <ChevronDown />
                      </IconButton>
                    ) : (
                      <IconButton
                        sx={{
                          '& .MuiSvgIcon-root': {
                            color: 'black'
                          },
                          padding: 0
                        }}
                      >
                        <ChevronRight />
                      </IconButton>
                    )}
                  </button>
                ) : null}
              </Stack>

              <Stack
                sx={{
                  position: 'relative'
                }}
                maxWidth={'100%'}
                direction="row"
                alignItems="center"
              >
                <Tooltip
                  title={`${row.transcript}(MANE)`}
                  placement={'top-start'}
                  disableHoverListener={NM.length <= 14}
                >
                  <TypographyA
                    id="qw"
                    sx={{
                      width: '100%',
                      color:
                        bgcolor === 'rgba(229,38,35,0.8)'
                          ? 'white'
                          : bgcolor === 'rgb(107,148,200,0.8)' ||
                            bgcolor === 'rgb(109,56,149,0.8)'
                          ? 'black'
                          : '#23527c',
                      maxWidth: 140,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      window.open(
                        `${ExternalLinks.ncbi.nuccore}/${row.transcript}`
                      )
                    }}
                  >
                    {NM.length >= 14 ? `${NM}` : NM}
                  </TypographyA>
                </Tooltip>

                {/* <IconButton
                  onClick={(e) => {
                    props.setTranscript_list(row.transcript_list)

                    props.handleMenuClick(e, 'list')
                  }}
                  sx={{
                    color: 'inherit',
                    padding: 0

                    // position: 'absolute',
                    // right: 0,
                    // bottom: '-1rem'
                  }}
                  size="small"
                >
                  <MenuDown />
                </IconButton> */}
              </Stack>
            </Stack>
          )
        },
        ...props.getColumnSearchProps('gene')
      },
      {
        dataIndex: 'dbSNP',
        key: 'dbSNP',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth="100%">
            <Stack maxWidth="100%">
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Position')}
              </span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('dbSNP')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          let bgcolor = color.find(
            (i) => i.key === row.CLINSIG_final?.toLowerCase()
          )
            ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                ?.color as any)
            : 'rgba(0, 0, 0)'

          // loss_of_function等于1 并且CLINSIG_final不等于P/LP
          if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
            //
          } else if (row.CLINSIG_final?.toLowerCase() === 'likely pathogenic') {
            //
          } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

          return (
            <Stack maxWidth={'100%'} direction="column" spacing={1}>
              <TypographyA
                sx={{
                  cursor: 'pointer',
                  color:
                    bgcolor === 'rgba(229,38,35,0.8)'
                      ? 'white'
                      : bgcolor === 'rgb(107,148,200,0.8)' ||
                        bgcolor === 'rgb(109,56,149,0.8)'
                      ? 'black'
                      : '#23527c',
                  fontWeight: '700'
                }}
                onClick={(e) => {
                  if (
                    (props.analysisInfo && props.analysisInfo.bamFile) ||
                    props.analysisInfo.sampleType === 'fastq'
                  ) {
                    props.handleMenuClick(e, 'IGV')

                    props.setCurrent(row)
                  } else if (
                    props.analysisInfo.analysisType === 'family_analysis' ||
                    props.analysisInfo.analysisType === 'big_family'
                  ) {
                    const fqSamples = props.analysisInfo.samples?.filter(
                      (item: any) => item && item.sampleType === 'fastq'
                    )

                    //

                    if (fqSamples && fqSamples.length) {
                      props.handleMenuClick(e, 'IGV')

                      props.setCurrent(row)
                    } else {
                      window.open(
                        `${ExternalLinks.genome}?db=${
                          props.analysisInfo.genomeBuild ?? 'hg19'
                        }&lastVirtModeType=default&lastVirtModeExtraState=&virtModeType=default&virtMode=0&nonVirtPosition=&position=chr${
                          row.chrom
                        }:${row.pos}-${row.pos}`
                      )
                    }
                  } else
                    window.open(
                      `${ExternalLinks.genome}?db=${
                        props.analysisInfo.genomeBuild ?? 'hg19'
                      }&lastVirtModeType=default&lastVirtModeExtraState=&virtModeType=default&virtMode=0&nonVirtPosition=&position=chr${
                        row.chrom
                      }:${row.pos}-${row.pos}`
                    )
                }}
              >
                {`${row.chrom}:${row.pos}`}
              </TypographyA>

              <Tooltip
                disableHoverListener={row.rs_id?.length <= 14}
                title={row.rs_id}
                placement={'top-start'}
              >
                <TypographyA
                  sx={{
                    color:
                      bgcolor === 'rgba(229,38,35,0.8)'
                        ? 'white'
                        : bgcolor === 'rgb(107,148,200,0.8)' ||
                          bgcolor === 'rgb(109,56,149,0.8)'
                        ? 'black'
                        : '#23527c',
                    cursor: 'pointer',
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    fontWeight: '700'
                  }}
                  onClick={() => {
                    window.open(
                      `${ExternalLinks.ncbi.snp_ref}?type=rs&rs=${row.rs_id}`
                    )
                  }}
                >
                  {`${row.rs_id}`}
                </TypographyA>
              </Tooltip>
            </Stack>
          )
        },
        ...props.getColumnSearchProps('dbSNP')

        // filters: chromosome
      },
      {
        dataIndex: 'coding_effect',
        key: 'coding_effect',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Function')}
              </span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {`${t('Location')}`}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => (
          <Stack maxWidth={'100%'} direction="column" spacing={1}>
            <Tooltip
              disableHoverListener={row.coding_effect?.length <= 14}
              placement={'top-start'}
              title={row.coding_effect}
            >
              <TypographyA
                sx={{
                  maxWidth: 100,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >{`${row.coding_effect}`}</TypographyA>
            </Tooltip>

            <Tooltip
              disableHoverListener={
                row.var_location?.length + row.exon?.length <= 14
              }
              placement={'top-start'}
              title={`${row.var_location}${
                row.exon === '.' ? '' : `(${row.exon})`
              }`}
            >
              <TypographyA
                sx={{
                  maxWidth: 100,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              >{`${row.var_location}${
                row.exon === '.' ? '' : `(${row.exon})`
              }`}</TypographyA>
            </Tooltip>
          </Stack>
        ),
        ...props.getColumnSearchProps('coding_effect')
      },
      {
        dataIndex: 'nuc_change',
        key: 'nuc_change',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <React.Fragment>
            <Stack maxWidth="100%">
              <span
                style={{
                  textAlign: 'start'
                }}
              >
                {t('Base change')}
              </span>
            </Stack>
          </React.Fragment>
        ),
        render: (value, row: any) => (
          <Stack maxWidth={'100%'} direction="column" spacing={1}>
            <Box>
              <Tooltip
                disableHoverListener={row.nuc_change?.length <= 14}
                title={`${row.nuc_change}`}
                placement="top-start"
              >
                <TypographyA
                  sx={{
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.nuc_change}`}
                </TypographyA>
              </Tooltip>

              <Tooltip
                disableHoverListener={row.c_nomen?.length <= 14}
                title={`${row.c_nomen}`}
                placement="top-start"
              >
                <TypographyA
                  sx={{
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.c_nomen}`}
                </TypographyA>
              </Tooltip>

              <Tooltip
                disableHoverListener={row.p_nomen?.length <= 14}
                title={`${row.p_nomen}`}
                placement="top-start"
              >
                <TypographyA
                  sx={{
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.p_nomen}`}
                </TypographyA>
              </Tooltip>
            </Box>
          </Stack>
        )
      },
      {
        title: () => (
          <Tooltip
            title={
              user && user.organization && user.organization.isShared ? (
                <>
                  <p>组织下有该基因的样本量/平台有该基因的样本量</p>

                  <p>组织下有该变异的样本量/组织下的总样本量</p>

                  <p>平台上有该变异的样本量/平台上的总样本量</p>
                </>
              ) : (
                <>
                  <p>账户下有该基因的样本量/平台有该基因的样本量</p>

                  <p>账户下有该变异的样本量/账户下的总样本量</p>

                  <p>平台上有该变异的样本量/平台上的总样本量</p>
                </>
              )
            }
          >
            <Stack maxWidth={'100%'} direction={'column'} alignItems="center">
              <Stack maxWidth={'100%'}>
                <React.Fragment>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Gene Index')}
                  </span>
                </React.Fragment>
              </Stack>

              <Stack maxWidth={'100%'}>
                <React.Fragment>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Variant Index (local)')}
                  </span>
                </React.Fragment>
              </Stack>

              <Stack maxWidth={'100%'}>
                <React.Fragment>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Variant Index (GLS)')}
                  </span>
                </React.Fragment>
              </Stack>
            </Stack>
          </Tooltip>
        ),
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        width: 80,
        ellipsis: true,
        render: (value, row: any) => {
          const Index = row.Index
          const GeneIndex = row.GeneIndex

          let bgcolor = color.find(
            (i) => i.key === row.CLINSIG_final?.toLowerCase()
          )
            ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                ?.color as any)
            : 'rgba(0, 0, 0)'

          // loss_of_function等于1 并且CLINSIG_final不等于P/LP
          if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
            //
          } else if (row.CLINSIG_final?.toLowerCase() === 'likely pathogenic') {
            //
          } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

          return (
            <Stack maxWidth={'100%'} direction="column" spacing={1}>
              {GeneIndex ? (
                <React.Fragment>
                  <TypographyA
                    sx={{
                      width: '100%',
                      maxWidth: 140,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                      color:
                        bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c'
                    }}
                    onClick={() => {
                      props.setCurrent(row)

                      props.setGeneIndexOpen(true)
                    }}
                  >
                    {`${GeneIndex.accountTotal} / ${GeneIndex.platformTotal}`}
                  </TypographyA>
                </React.Fragment>
              ) : (
                ''
              )}

              {Index ? (
                <React.Fragment>
                  <TypographyA
                    sx={{
                      width: '100%',
                      maxWidth: 140,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                      color:
                        bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c'
                    }}
                    onClick={() => {
                      props.setCurrent(row)

                      props.setIndexOpen(true)
                    }}
                  >
                    {user && user.organization && user.organization.isShared
                      ? `${row.Index.organizationTotal} / ${row.Index.organizationTotalSamples}`
                      : `${row.Index.accountTotal} / ${row.Index.userTotalSamples}`}
                  </TypographyA>

                  <TypographyA
                    sx={{
                      width: '100%',
                      maxWidth: 140,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                      color:
                        bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c'
                    }}
                    onClick={() => {
                      props.setCurrent(row)

                      props.setIndexOpen(true)
                    }}
                  >
                    {`${row.Index.platformTotal} / ${
                      row.Index.glsTotalSamples + row.Index.btgTotalSamples
                    }`}
                  </TypographyA>
                </React.Fragment>
              ) : (
                ''
              )}
            </Stack>
          )
        },
        ...props.getColumnSearchProps('index')
      },
      {
        dataIndex: 'articles',
        key: 'articles',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
            <Stack maxWidth={'100%'}>
              <React.Fragment>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Articles')}
                </span>
              </React.Fragment>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          const LitVarArticles = row.LitVarArticles
          const Articles = row.Articles
          let bgcolor = color.find(
            (i) => i.key === row.CLINSIG_final?.toLowerCase()
          )
            ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                ?.color as any)
            : 'rgba(0, 0, 0)'

          // loss_of_function等于1 并且CLINSIG_final不等于P/LP
          if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
            //
          } else if (row.CLINSIG_final?.toLowerCase() === 'likely pathogenic') {
            //
          } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

          return (
            <Stack
              onClick={(e) => {
                //
                e.stopPropagation()

                props.setAcmgOpen(true)

                props.setCurrent && props.setCurrent(row)

                setTimeout(() => {
                  props.VariationGeneRef.current &&
                    props.VariationGeneRef.current.handleClickLeft &&
                    props.VariationGeneRef.current.handleClickLeft(
                      3,
                      'Publication'
                    )
                }, 2000)
              }}
              maxWidth={'100%'}
              direction="column"
              spacing={1}
              sx={{
                cursor: 'pointer'
              }}
            >
              {LitVarArticles?.count ? (
                <TypographyA
                  sx={{
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color:
                      bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c'
                  }}
                >
                  LitVar:{LitVarArticles?.count ?? 0}
                </TypographyA>
              ) : (
                ''
              )}

              {Articles?.variantPubmedArticlesCount ? (
                <TypographyA
                  sx={{
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color:
                      bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c'
                  }}
                >
                  Clinvar:{Articles?.variantPubmedArticlesCount ?? 0}
                </TypographyA>
              ) : (
                ''
              )}

              {Articles?.genePubmedArticlesCount ? (
                <TypographyA
                  sx={{
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color:
                      bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c'
                  }}
                >
                  OMIM:{Articles?.genePubmedArticlesCount ?? 0}
                </TypographyA>
              ) : (
                ''
              )}
            </Stack>
          )
        }
      },
      {
        dataIndex: 'odds_ratio',
        key: 'odds_ratio',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('OR')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA
                sx={{
                  color: '#23527c',
                  fontWeight: '700'
                }}
              >
                {row.odds_ratio ? row.odds_ratio.toFixed(4) : row.odds_ratio}
              </TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'p_value',
        key: 'p_value',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('P-Value')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA
                sx={{
                  color: '#23527c',
                  fontWeight: '700'
                }}
              >
                {row.p_value ? Number(row.p_value).toFixed(4) : '.'}
              </TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'confidence_interval',
        key: 'confidence_interval',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('95% confidence interval')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          const confidence_interval = row.confidence_interval
          if (confidence_interval && confidence_interval.includes(':')) {
            const confidence = Number(
              confidence_interval.split(':')[0]
            ).toFixed(4)
            const interval = Number(confidence_interval.split(':')[1]).toFixed(
              4
            )

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA
                  sx={{
                    color: '#23527c',
                    fontWeight: '700'
                  }}
                >
                  {`${confidence}:${interval}`}
                </TypographyA>
              </Stack>
            )
          } else
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA
                  sx={{
                    color: '#23527c',
                    fontWeight: '700'
                  }}
                >
                  {row.confidence_interval}
                </TypographyA>
              </Stack>
            )
        }
      },
      {
        dataIndex: 'total_cases',
        key: 'total_cases',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('Total Cases')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA
                sx={{
                  color: '#23527c',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  props.setSamplesOpen(true)

                  props.setCurrent(row)
                }}
              >
                {row.case_samples ? row.case_samples.length : 0}
              </TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'total_controls',
        key: 'total_controls',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('Total Controls')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA
                sx={{
                  color: '#23527c',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  props.setSamplesOpen(true)

                  props.setCurrent(row)
                }}
              >
                {row.control_samples ? row.control_samples.length : 0}
              </TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'gnomAD_exome_ALL',
        key: 'gnomAD_exome_ALL',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>{`${t(
                'gAD'
              )}_ALL`}</span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>{`${t(
                'gAD'
              )}_EAS`}</span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => (
          <Stack maxWidth={'100%'} direction="column">
            <TypographyA
              sx={{
                maxWidth: '100%'
              }}
            >
              {row.gnomAD_exome_ALL === '.'
                ? '.'
                : row.gnomAD_exome_ALL === 0
                ? 0
                : `${row.gnomAD_exome_ALL?.toFixed(8)}`}
            </TypographyA>

            <TypographyA
              sx={{
                maxWidth: '100%'
              }}
            >
              {(row.gnomAD_exome_EAS as unknown as string) === '.'
                ? '.'
                : row.gnomAD_exome_EAS === 0
                ? 0
                : `${row.gnomAD_exome_EAS?.toFixed(8)}`}
            </TypographyA>
          </Stack>
        )
      },
      {
        dataIndex: 'SpliceAI_max_score',
        key: 'SpliceAI_max_score',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} alignItems="center">
            <Tooltip
              title={`D(${t('harmful')}) U(${t('unknown significance')}) B(${t(
                'benign'
              )})`}
              placement="top-start"
            >
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('SpliceAI')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Revel')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('AlphaM')}
                </span>
              </Stack>
            </Tooltip>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack maxWidth={'100%'}>
              <Stack maxWidth={'100%'} direction="column" spacing={1}>
                <TypographyA
                  sx={{
                    fontSize: '0.8rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pr: '10px'
                  }}
                >
                  <span>
                    {(row.SpliceAI_max_score as unknown as string) === '.'
                      ? '.'
                      : `${row.SpliceAI_max_score?.toFixed(2)}`}
                  </span>

                  <span
                    style={{
                      fontWeight:
                        row.SpliceAI_max_score >= 0.2 ? 'bold' : 'normal'
                    }}
                  >
                    {`${
                      row.SpliceAI_max_score >= 0.2
                        ? 'D'
                        : row.SpliceAI_max_score <= 0.1
                        ? ''
                        : ''
                    }`}
                  </span>
                </TypographyA>

                <TypographyA
                  sx={{
                    fontSize: '0.8rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pr: '10px'
                  }}
                >
                  <span>
                    {(row.REVEL_score as unknown as string) === '.'
                      ? '.'
                      : `${row.REVEL_score?.toFixed(3)}`}
                  </span>

                  <span
                    style={{
                      fontWeight: row.REVEL_score >= 0.644 ? 'bold' : 'normal'
                    }}
                  >
                    {`${
                      row.REVEL_score >= 0.644
                        ? 'D'
                        : row.REVEL_score <= 0.29
                        ? ''
                        : ''
                    }`}
                  </span>
                </TypographyA>

                <TypographyA
                  sx={{
                    fontSize: '0.8rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pr: '10px'
                  }}
                >
                  <span>
                    {(row.AM_pathogenicity as unknown as string) === '.' ||
                    !row.AM_pathogenicity
                      ? '.'
                      : `${Number(row.AM_pathogenicity)?.toFixed(2)}`}
                  </span>

                  <span
                    style={{
                      fontWeight:
                        Number(row.AM_pathogenicity) >= 0.564
                          ? 'bold'
                          : 'normal'
                    }}
                  >
                    {`${
                      Number(row.AM_pathogenicity) >= 0.564
                        ? 'D'
                        : Number(row.AM_pathogenicity) <= 0.34
                        ? ''
                        : ''
                    }`}
                  </span>
                </TypographyA>
              </Stack>
            </Stack>
          )
        },
        ...props.getColumnSearchProps('SpliceAI_max_score')
      },
      {
        dataIndex: 'CLINVAR_variant_id',
        key: 'CLINVAR_variant_id',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Clinvar (star)')}
              </span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Curation')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          let bgcolor = color.find(
            (i) => i.key === row.CLINSIG_final?.toLowerCase()
          )
            ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                ?.color as any)
            : 'rgba(0, 0, 0)'

          // loss_of_function等于1 并且CLINSIG_final不等于P/LP
          if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
            //
          } else if (row.CLINSIG_final?.toLowerCase() === 'likely pathogenic') {
            //
          } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

          return (
            <Stack maxWidth={'100%'} direction={'column'} spacing={1}>
              <Stack
                alignItems={'center'}
                maxWidth={'100%'}
                spacing={1}
                direction="row"
              >
                <Tooltip
                  title={row.CLINVAR_clnsig_final}
                  placement={'top-start'}
                >
                  <TypographyA
                    sx={{
                      color:
                        bgcolor === 'rgba(229,38,35,0.8)' ? 'white' : '#23527c',
                      cursor: 'pointer',
                      maxWidth: 80,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                    onClick={() => {
                      window.open(
                        `${ExternalLinks.ncbi.variation}/${row.CLINVAR_variant_id}`
                      )
                    }}
                  >
                    {`${row.CLINVAR_clnsig_final}`}
                  </TypographyA>
                </Tooltip>

                {row.CLINVAR_gold_stars && row.CLINVAR_gold_stars !== '.' ? (
                  <Rating
                    readOnly
                    value={row.CLINVAR_gold_stars as unknown as number}
                    max={row.CLINVAR_gold_stars as unknown as number}
                  />
                ) : (
                  ''
                )}
              </Stack>

              <TypographyA
                sx={{
                  maxWidth: '100%'
                }}
              >
                {`${row.curation}`}
              </TypographyA>
            </Stack>
          )
        },
        filters: [
          {
            value: 'PAT',
            text: t('Pathogenic')
          },
          {
            value: 'LP',
            text: t('Likely Pathogenic')
          },
          {
            value: 'VUS',
            text: t('Uncertain Significance')
          },
          {
            value: 'LB',
            text: t('Likely Benign')
          },
          {
            value: 'BEN',
            text: t('Benign')
          },
          {
            value: 'CONF',
            text: t('Conf')
          }
        ]
      },
      {
        title: () => (
          <React.Fragment>
            {/* <Filters keys="ACMG_classification" /> */}

            <Stack maxWidth={'100%'} direction={'column'} alignItems="center">
              <span>{t('ACMG')}</span>

              <span>{t('Classification')}</span>
            </Stack>
          </React.Fragment>
        ),
        dataIndex: 'ACMG_priority',
        key: 'ACMG_priority',
        align: 'center',
        width: 80,
        ellipsis: true,
        render: (value, row: any) => {
          const acmg = row.ACMG_classification
            ? `${row.ACMG_classification}`
            : row.user_acmg_classification
            ? `${row.user_acmg_classification}`
            : ''

          let bgcolor = color.find((i) => i.key === acmg?.toLowerCase())
            ? (color.find((i) => i.key === acmg?.toLowerCase())?.color as
                | 'rgb(240,239,240,0.4)'
                | 'rgba(221,109,32,0.8)'
                | 'rgb(255,242,202)'
                | 'rgb(245,182,193)')
            : 'none'
          if (row.user_acmg_classification) {
            bgcolor = color.find(
              (i) => i.key === row.user_acmg_classification?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.user_acmg_classification?.toLowerCase()
                )?.color as
                  | 'rgb(240,239,240,0.4)'
                  | 'rgba(221,109,32,0.8)'
                  | 'rgb(255,242,202)'
                  | 'rgb(245,182,193)')
              : 'rgba(0, 0, 0)'

            return (
              <Stack maxWidth={'100%'}>
                <Box
                  sx={{
                    maxWidth: '100%',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                >
                  <Box>
                    <Chip
                      sx={{
                        bgcolor: bgcolor,
                        color:
                          bgcolor === 'rgb(240,239,240,0.4)'
                            ? 'black'
                            : 'white',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        minWidth: '45px',
                        textAlign: 'center'
                      }}
                      label={`${row.user_acmg_classification
                        .split(' ')
                        .map((word: string) => {
                          if (word.includes('Uncertain')) return `VU`
                          if (word.includes('null')) return ``
                          else return word[0].toUpperCase()
                        })
                        .join('')}${
                        row.ACMG_score || row.ACMG_score === 0
                          ? `:${row.ACMG_score}`
                          : ``
                      }`}
                      size="small"
                      onClick={() => {
                        props.setAcmgOpen(true)

                        props.setCurrent && props.setCurrent(row)
                      }}
                    />
                  </Box>

                  <Box>
                    {row.user_classification ? (
                      <Chip
                        key={row.user_classification}
                        size="small"
                        label={`${row.user_classification
                          .split(' ')
                          .map((word: any) => {
                            if (word.includes('Uncertain')) return `VU`
                            if (word.includes('uncertain')) return `VU`
                            if (word.includes('null')) return ``
                            else return word[0].toUpperCase()
                          })
                          .join('')}`}
                        sx={{
                          bgcolor: bgcolor,
                          color:
                            bgcolor === 'rgb(240,239,240,0.4)'
                              ? 'black'
                              : 'white',
                          justifyContent: 'center',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          textAlign: 'center',
                          minWidth: '45px'
                        }}
                        onClick={() => {
                          props.setCurrent(row)

                          props.setOpen(true)
                        }}
                      />
                    ) : (
                      <IconButton
                        aria-label="edit"
                        onClick={() => {
                          props.setCurrent(row)

                          props.setOpen(true)
                        }}
                        sx={{
                          padding: 0
                        }}
                      >
                        <CommentOutline
                          sx={{
                            fontSize: '1rem'
                          }}
                        />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              </Stack>
            )
          } else if (acmg !== '.' || row.user_acmg_classification !== '.') {
            return (
              <Stack maxWidth={'100%'}>
                {/* <TypographyA
                  sx={{
                    maxWidth: '100%',
                    textAlign: 'center'
                  }}
                >
                  {`${row.ACMG_score}`}
                </TypographyA> */}

                <Box
                  sx={{
                    maxWidth: '100%',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                >
                  <Box>
                    <Chip
                      sx={{
                        bgcolor: bgcolor,
                        color:
                          bgcolor === 'rgb(240,239,240,0.4)'
                            ? 'black'
                            : 'white',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        minWidth: '45px',
                        fontWeight: '700',
                        textAlign: 'center'
                      }}
                      label={`${acmg
                        ?.split(' ')
                        .map((word: string) => {
                          if (word.includes('Uncertain')) return `VU`
                          if (word.includes('null')) return ``
                          else return word[0].toUpperCase()
                        })
                        .join('')}${
                        row.ACMG_score || row.ACMG_score === 0
                          ? `:${row.ACMG_score}`
                          : ``
                      }`}
                      size="small"
                      onClick={() => {
                        props.setAcmgOpen(true)

                        props.setCurrent && props.setCurrent(row)
                      }}
                    />
                  </Box>

                  <Box>
                    {row.user_classification ? (
                      <Chip
                        key={row.user_classification}
                        size="small"
                        label={`${row.user_classification
                          .split(' ')
                          .map((word: any) => {
                            if (word.includes('Uncertain')) return `VU`
                            if (word.includes('uncertain')) return `VU`
                            if (word.includes('null')) return ``
                            else return word[0].toUpperCase()
                          })
                          .join('')}`}
                        sx={{
                          bgcolor: bgcolor,
                          color:
                            bgcolor === 'rgb(240,239,240,0.4)'
                              ? 'black'
                              : 'white',
                          justifyContent: 'center',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          textAlign: 'center',
                          minWidth: '45px'
                        }}
                        onClick={() => {
                          props.setCurrent(row)

                          props.setOpen(true)
                        }}
                      />
                    ) : (
                      <IconButton
                        aria-label="edit"
                        onClick={() => {
                          props.setCurrent(row)

                          props.setOpen(true)
                        }}
                        sx={{
                          padding: 0
                        }}
                      >
                        <CommentOutline
                          sx={{
                            fontSize: '1rem'
                          }}
                        />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              </Stack>
            )
          } else
            return (
              <>
                <TypographyA
                  sx={{
                    maxWidth: '100%',
                    textAlign: 'center'
                  }}
                >
                  {`${row.ACMG_score}`}
                </TypographyA>

                <TypographyA textAlign={'center'}>.</TypographyA>
              </>
            )
        },

        // filters: [
        //   {
        //     value: 'Pathogenic',
        //     text: 'Pathogenic'
        //   },
        //   {
        //     value: 'Likely pathogenic',
        //     text: 'Likely Pathogenic'
        //   },
        //   {
        //     value: 'Uncertain significance',
        //     text: 'Uncertain Significance'
        //   },
        //   {
        //     value: 'Likely benign',
        //     text: 'Likely Benign'
        //   },
        //   {
        //     value: 'Benign',
        //     text: 'Benign'
        //   }
        // ],
        sorter: true,
        ...props.getColumnSearchProps('ACMG_priority')
      },
      {
        dataIndex: 'inheritance',
        key: 'inheritance',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack width={'100%'} direction={'row'} justifyContent="center">
            <Stack maxWidth={'100%'} justifyContent="center">
              {props.query && props.query.key && props.query.key === '5' ? (
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Disease Information')}
                </span>
              ) : (
                <React.Fragment>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('OMIM')}
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Inheritance')}
                  </span>
                </React.Fragment>
              )}
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          if (props.query && props.query.key && props.query.key === '5') {
            return (
              <Stack maxWidth={'100%'} spacing={1}>
                {row.MitoMap && row.MitoMap.disease_ch ? (
                  <Tooltip
                    title={
                      <>
                        <Typography color={'white'}>
                          {row.MitoMap.disease_ch}
                        </Typography>

                        <Typography color={'white'}>
                          {row.MitoMap.info}
                        </Typography>
                      </>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        maxWidth: isWindow() ? '400px' : '200px'
                      }
                    }}
                  >
                    <Box>
                      <TypographyA
                        sx={{
                          width: '100%',
                          maxWidth: 200,
                          lineHeight: '24px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                          mb: '4px'
                        }}
                        key={`${row.MitoMap.disease_ch}`}
                      >
                        {row.MitoMap.disease_ch}
                      </TypographyA>

                      <TypographyA
                        sx={{
                          width: '100%',
                          maxWidth: 200,
                          lineHeight: '24px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                          mb: '4px'
                        }}
                        key={`${row.MitoMap.info}`}
                      >
                        {row.MitoMap.info}
                      </TypographyA>
                    </Box>
                  </Tooltip>
                ) : (
                  <TypographyA>.</TypographyA>
                )}
              </Stack>
            )
          } else if (
            row.OMIM?.geneDiseaseTranslated &&
            row.OMIM?.geneDiseaseTranslated.data
          ) {
            let OMIMValue = row.OMIM?.geneDiseaseTranslated?.data

            OMIMValue = unique(OMIMValue, 'disease')

            let bgcolor = color.find(
              (i) => i.key === row.CLINSIG_final?.toLowerCase()
            )
              ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                  ?.color as any)
              : 'rgba(0, 0, 0)'

            // loss_of_function等于1 并且CLINSIG_final不等于P/LP
            if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
              //
            } else if (
              row.CLINSIG_final?.toLowerCase() === 'likely pathogenic'
            ) {
              //
            } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

            return (
              <Stack maxWidth={'100%'} spacing={1}>
                {OMIMValue && OMIMValue.length ? (
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        {OMIMValue.map((item: any, index: any) => (
                          <TypographyA
                            sx={{
                              fontSize: '0.85rem',
                              lineHeight: '1rem',
                              maxWidth: isWindow()
                                ? '400px !important'
                                : '200px !important'
                            }}
                            key={`${item.disease}_${index}`}
                          >
                            {`(${
                              item.genetic_mode ? item.genetic_mode : '.'
                            })-${
                              i18n && i18n.language === 'zh' ? item.disease : ''
                            }`}
                          </TypographyA>
                        ))}
                      </React.Fragment>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        maxWidth: isWindow() ? '400px' : '200px'
                      }
                    }}

                    // enterDelay={1000}
                    // onMouseEnter={async (e) => {
                    //   const sourceLanguage = 'en',
                    //     targetLanguage = 'zh'
                    //   const params: TranslateDto = {
                    //     sourceLanguage,
                    //     targetLanguage,
                    //     sourceText: OMIMValue
                    //   }
                    //   Translate.mutateAsync(params)
                    // }}
                  >
                    <Box>
                      {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                        return (
                          <TypographyA
                            sx={{
                              width: '100%',
                              maxWidth: 200,
                              lineHeight: '24px',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              cursor: 'pointer',
                              color:
                                bgcolor === 'rgb(109,56,149,0.8)' ||
                                bgcolor === 'rgb(107,148,200,0.8)' ||
                                bgcolor === 'rgba(229,38,35,0.8)'
                                  ? 'white'
                                  : '#23527c',
                              mb: '4px'
                            }}
                            onClick={() => {
                              props.setCurrent(row)

                              props.setOMIMOpen(true)
                            }}
                            key={`${items.disease}_${index}`}
                          >
                            <Chip
                              label={`${
                                items.genetic_mode ? items.genetic_mode : '.'
                              }`}
                              size="small"
                              sx={{
                                height: 18,
                                fontSize: '0.75rem',
                                fontWeight: '700'
                              }}
                            />

                            <span
                              style={{
                                lineHeight: '24px'
                              }}
                            >{`${
                              i18n && i18n.language === 'zh'
                                ? items.disease + '-'
                                : ''
                            }${items.disease}`}</span>
                          </TypographyA>
                        )
                      })}

                      {/* {OMIMValue.length > 3 ? '...' : ''} */}
                    </Box>
                  </HtmlTooltip>
                ) : (
                  <TypographyA>.</TypographyA>
                )}
              </Stack>
            )
          } else {
            let OMIMValue =
              row.OMIM?.omimData.map((item: any) => {
                const inheritances: string[] = []

                if (
                  item &&
                  item.clinicalSynopsis &&
                  item.clinicalSynopsis.INHERITANCE &&
                  Array.isArray(item.clinicalSynopsis.INHERITANCE)
                ) {
                  item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                    inheritances.push(str.toLowerCase())
                  )
                }
                const inheritance = formatVariantInheritance(
                  Array.from([...new Set(inheritances)]).join(',')
                )

                return {
                  ...item,
                  inheritance
                }
              }) ?? []

            OMIMValue = unique(OMIMValue, 'phenoName')

            let bgcolor = color.find(
              (i) => i.key === row.CLINSIG_final?.toLowerCase()
            )
              ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                  ?.color as any)
              : 'rgba(0, 0, 0)'

            // loss_of_function等于1 并且CLINSIG_final不等于P/LP
            if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
              //
            } else if (
              row.CLINSIG_final?.toLowerCase() === 'likely pathogenic'
            ) {
              //
            } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

            return (
              <Stack maxWidth={'100%'} spacing={1}>
                {OMIMValue && OMIMValue.length ? (
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        {OMIMValue.map((item: any, index: any) => (
                          <TypographyA
                            sx={{
                              fontSize: '0.85rem',
                              lineHeight: '1rem',
                              maxWidth: isWindow()
                                ? '400px !important'
                                : '200px !important'
                            }}
                            key={`${item.phenoName}_${index}`}
                          >
                            {`(${item.inheritance ? item.inheritance : '.'})-${
                              i18n && i18n.language === 'zh'
                                ? item.pheno_name_cn + '-'
                                : ''
                            }${item.phenoName}`}
                          </TypographyA>
                        ))}
                      </React.Fragment>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        maxWidth: isWindow() ? '400px' : '200px'
                      }
                    }}

                    // enterDelay={1000}
                    // onMouseEnter={async (e) => {
                    //   const sourceLanguage = 'en',
                    //     targetLanguage = 'zh'
                    //   const params: TranslateDto = {
                    //     sourceLanguage,
                    //     targetLanguage,
                    //     sourceText: OMIMValue
                    //   }
                    //   Translate.mutateAsync(params)
                    // }}
                  >
                    <Box>
                      {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                        return (
                          <TypographyA
                            sx={{
                              width: '100%',
                              maxWidth: 200,
                              lineHeight: '24px',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              cursor: 'pointer',
                              color:
                                bgcolor === 'rgb(109,56,149,0.8)' ||
                                bgcolor === 'rgb(107,148,200,0.8)' ||
                                bgcolor === 'rgba(229,38,35,0.8)'
                                  ? 'white'
                                  : '#23527c',
                              mb: '4px'
                            }}
                            onClick={() => {
                              props.setCurrent(row)

                              props.setOMIMOpen(true)
                            }}
                            key={`${items.phenoMim}_${index}`}
                          >
                            <Chip
                              label={`${
                                items.inheritance ? items.inheritance : '.'
                              }`}
                              size="small"
                              sx={{
                                height: 18,
                                fontSize: '0.75rem',
                                fontWeight: '700'
                              }}
                            />

                            <span
                              style={{
                                lineHeight: '24px'
                              }}
                            >{`${
                              i18n && i18n.language === 'zh'
                                ? items.pheno_name_cn + '-'
                                : ''
                            }${items.phenoName}`}</span>
                          </TypographyA>
                        )
                      })}

                      {/* {OMIMValue.length > 3 ? '...' : ''} */}
                    </Box>
                  </HtmlTooltip>
                ) : (
                  <TypographyA>.</TypographyA>
                )}
              </Stack>
            )
          }
        }
      },
      {
        dataIndex: 'SampleInfo',
        key: 'SampleInfo',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Sample Info')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack maxWidth={'100%'} direction={'column'} spacing={1}>
              <Button
                variant="contained"
                onClick={() => {
                  props.setSampleInfoOpen(true)

                  props.setCurrent(row)
                }}
                size={'small'}
              >
                {t('F score')}
              </Button>
            </Stack>
          )
        }
      }
    ]

    if (!props.indexChecked) {
      column = column.filter((i) => i.key !== 'index')
    }

    return column
  }, [props, user])

  React.useImperativeHandle(ref, () => ({
    column
  }))

  return <></>
})

export default columns2CohortSites
